// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { MonevListResponse } from "./types";

import * as monevActions from "./monev.actions";

export function* getMonev(
  action: ReturnType<typeof monevActions.getMonevAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `monev?dokId=${action.payload.DOK_ID}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: MonevListResponse = yield call(result.json.bind(result));
      yield put(monevActions.getMonevAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(monevActions.getMonevAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(monevActions.getMonevAsync.failure(parsed));
  }
}

export default function* monevSagaGetMonev() {
  yield takeEvery(monevActions.getMonevAsync.request, getMonev);
}
